<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { inquiryFiscalYearConfigv2, saveOrUpdateFiscalYearConfig, deleteFiscalYearConfig } from '../../../../../api/home.js';
export default {
	name: 'FiscalYearSetup',
	data() {
		return {
			/* 表格 */
			pagination: getdata().pagination,
			headData: JSON.parse(localStorage.getItem('FiscalYearSetupheadData')) || getdata().headData,
			outlist: JSON.parse(localStorage.getItem('FiscalYearSetupoutlist')) || [],
			shaidiag: false,
			tableData: [],
			tablekey: 0,
			/* 表格 */
			// 弹框
			popupTitle: '新增财年',
			popup: false,
			formlist: getdata().formlist,
			formdata: getdata().formdata,
			headDatacn: getdata().headDatacn,
			tableDatacn: [
				{
					pijian: '第1期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第2期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第3期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第4期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第5期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第6期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第7期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第8期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第9期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第10期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第11期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第12期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第13期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第14期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第15期间',
					periodState: '1',
					annualCarryForwardState: '1'
				},
				{
					pijian: '第16期间',
					periodState: '1',
					annualCarryForwardState: '1'
				}
			],
			Count: 0
		};
	},
	created() {
		this.searrchForData();
	},
	mounted() {},
	methods: {
		//表格筛选
		closeshaidiag() {
			this.shaidiag = false;
		},
		confirmfilter(e) {
			localStorage.setItem('FiscalYearSetupoutlist', JSON.stringify(e.nochooselist));
			localStorage.setItem('FiscalYearSetupheadData', JSON.stringify(e.chooselist));
			this.headData = e.chooselist;
			this.outlist = e.nochooselist;
			this.shaidiag = false;
			this.$refs.tablebox.dout();
			this.tablekey++;
			this.getCloseoutPageList();
		},
		selectionchange(e) {
			this.Count = e.length;
		},
		//删除
		shanghcu(id) {
			if (id == '-1') {
				if (this.$refs.tablebox.getSelectionval().length == 0) {
					this.$message.error('请选择要删除的数据');
					return;
				}
			}
			let params = {};
			this.$showConfirm({
				message: '确认删除?'
			}).then(res => {
				if (res == 'confirm') {
					if (id == '-1') {
						params.ids = this.$refs.tablebox
							.getSelectionval()
							.map(v => v.id)
							.join(',');
					} else {
						params.ids = id;
					}
					deleteFiscalYearConfig(params).then(res => {
						if (res.data.code == '200') {
							this.$message.success('删除成功');
							this.searrchForData();
						} else {
							this.$message.error(res.data.message);
						}
					});
				}
			});
		},
		getdata() {
			let params = {};
			if (this.formdata.id) {
				params.id = this.formdata.id;
			}
			params.fiscalYear = this.formdata.fiscalYear;
			params.fiscalYearState = this.formdata.fiscalYearState;
			for (var i = 0; i < this.tableDatacn.length; i++) {
				params['periodState' + (i + 1)] = this.tableDatacn[i].periodState;
				params['annualCarryForwardState' + (i + 1)] = this.tableDatacn[i].annualCarryForwardState;
			}
			saveOrUpdateFiscalYearConfig(params).then(res => {
				if (res.data.code == '200') {
					this.$message.success('操作成功');
					this.searrchForData();
					this.popup = false;
				} else {
					this.$message.error(res.data.message);
				}
			});
		},
		baocun() {
			this.$refs.taxform.submitForm();
		},
		popuptk(date) {
			if (date == '-1') {
				this.popupTitle = '新建财年';
				this.formdata = {
					id: '',
					fiscalYear: '',
					fiscalYearState: '1'
				};
				this.tableDatacn = [
					{
						pijian: '第1期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第2期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第3期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第4期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第5期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第6期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第7期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第8期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第9期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第10期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第11期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第12期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第13期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第14期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第15期间',
						periodState: '1',
						annualCarryForwardState: '1'
					},
					{
						pijian: '第16期间',
						periodState: '1',
						annualCarryForwardState: '1'
					}
				];
			} else {
				this.popupTitle = '编辑财年';
				this.formdata = {
					id: date.id,
					fiscalYear: date.fiscalYear,
					fiscalYearState: date.fiscalYearState
				};
				this.tableDatacn = [
					{
						pijian: '第1期间',
						periodState: date.periodState1,
						annualCarryForwardState: date.annualCarryForwardState1
					},
					{
						pijian: '第2期间',
						periodState: date.periodState2,
						annualCarryForwardState: date.annualCarryForwardState2
					},
					{
						pijian: '第3期间',
						periodState: date.periodState3,
						annualCarryForwardState: date.annualCarryForwardState3
					},
					{
						pijian: '第4期间',
						periodState: date.periodState4,
						annualCarryForwardState: date.annualCarryForwardState4
					},
					{
						pijian: '第5期间',
						periodState: date.periodState5,
						annualCarryForwardState: date.annualCarryForwardState5
					},
					{
						pijian: '第6期间',
						periodState: date.periodState6,
						annualCarryForwardState: date.annualCarryForwardState6
					},
					{
						pijian: '第7期间',
						periodState: date.periodState7,
						annualCarryForwardState: date.annualCarryForwardState7
					},
					{
						pijian: '第8期间',
						periodState: date.periodState8,
						annualCarryForwardState: date.annualCarryForwardState8
					},
					{
						pijian: '第9期间',
						periodState: date.periodState9,
						annualCarryForwardState: date.annualCarryForwardState9
					},
					{
						pijian: '第10期间',
						periodState: date.periodState10,
						annualCarryForwardState: date.annualCarryForwardState10
					},
					{
						pijian: '第11期间',
						periodState: date.periodState11,
						annualCarryForwardState: date.annualCarryForwardState11
					},
					{
						pijian: '第12期间',
						periodState: date.periodState12,
						annualCarryForwardState: date.annualCarryForwardState12
					},
					{
						pijian: '第13期间',
						periodState: date.periodState13,
						annualCarryForwardState: date.annualCarryForwardState13
					},
					{
						pijian: '第14期间',
						periodState: date.periodState14,
						annualCarryForwardState: date.annualCarryForwardState14
					},
					{
						pijian: '第15期间',
						periodState: date.periodState15,
						annualCarryForwardState: date.annualCarryForwardState15
					},
					{
						pijian: '第16期间',
						periodState: date.periodState16,
						annualCarryForwardState: date.annualCarryForwardState16
					}
				];
			}
			this.popup = true;
			this.$nextTick(() => {
				this.$refs['taxform'].clearValidate();
				this.$refs.tableboxcn.dout()
			});
		},
		searrchForData() {
			let params = { page: this.pagination.pageNum, rows: this.pagination.pageSize, sort: '', order: '', criteriaJson: {} };
			inquiryFiscalYearConfigv2(params).then(res => {
				if (res.data.code == '200') {
					this.tableData = res.data.data;
					this.pagination.total = res.data.count;
				}
			});
		},
		/* 表格 */
		currentChange(e) {
			this.pagination.pageNum = e;
			this.searrchForData();
		},
		sizechange(e) {
			this.pagination.pageSize = e;
			this.searrchForData();
		}
		/* 表格 */
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
